import { Outlet } from 'react-router-dom';

import { values } from 'lodash-es';

import { MainLayoutBase } from '@/layout/mainLayout/MainLayoutBase';
import type { LookoRouteObject } from '@/router/LookoRouteObject';

export const 상세설명_편집기_라우터 = {
  루트: {
    path: '/settings/platform-post/detail-page/editor',
    async lazy() {
      const { default: Page } = await import('@/router/settings/platform-post/상세설명_편집기');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품글 양식 설정',
    },
  } satisfies LookoRouteObject,
};

export const 상세설명_편집기_루트: LookoRouteObject = {
  path: '/',
  element: (
    <MainLayoutBase headerHeight={0}>
      <Outlet />
    </MainLayoutBase>
  ),
  children: values(상세설명_편집기_라우터),
};
